<template>
  <div class="biz-add-announcement-page">
    <div class="page-header">
      <h1>Dodaj ogłoszenie</h1>
      <button class="btn-outline" @click="$router.push('/dla-biznesu/profile/announcements/')">Wróć do listy</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Nowe ogłoszenie</h2>
        <p class="section-subtitle">Uzupełnij formularz i opublikuj ogłoszenie do weryfikacji.</p>
      </div>

      <form class="announcement-form" @submit="(e) => addAnnouncement(e)">
        <div class="form-group">
          <label for="title">Tytuł</label>
          <input id="title" type="text" placeholder="Tytuł" v-model="announcement.title" name="title" required maxlength="50" minlength="3">
        </div>

        <div class="form-group">
          <label for="short_description">Krótki opis</label>
          <textarea id="short_description" placeholder="Krótki opis" v-model="announcement.short_description" name="short_description" required maxlength="350" minlength="20"></textarea>
        </div>

        <div class="form-group">
          <label for="content">Treść</label>
          <textarea id="content" placeholder="Treść ogłoszenia" v-model="announcement.content" name="content" required maxlength="3000" minlength="80"></textarea>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label for="contact">Adres e-mail do kontaktu</label>
            <input id="contact" type="email" placeholder="Adres e-mail do kontaktu" autocomplete="email" v-model="announcement.contact" maxlength="50" required>
          </div>

          <div class="form-group">
            <label for="target">Odbiorcy</label>
            <select name="target" id="target" v-model="announcement.target" required>
              <option>do wszystkich</option>
              <option>do specjalistów</option>
              <option>do właścicieli zwierząt</option>
            </select>
          </div>

          <div class="form-group">
            <label for="category">Kategoria</label>
            <select name="category" id="category" v-model="announcement.category" required>
              <option>sprzedaż</option>
              <option>współpraca</option>
              <option>wymiana</option>
              <option>inne</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="announcementImage">Zdjęcie wyróżniające</label>
          <input type="file" id="announcementImage" @change="(e) => onFileUpload(e)" accept="image/png, image/jpeg">
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">Zatwierdź</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizAddAnnouncementVue',
  setup() {
    useMeta({ title: 'Dodaj ogłoszenia' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      announcement: {
        title: '',
        short_description: '',
        content: '',
        contact: '',
        photo: null,
        target: 'do wszystkich',
        category: 'sprzedaż',
      },
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
  },
  methods: {
    onFileUpload(e) {
      this.announcement.photo = e.target.files[0];
    },
    addAnnouncement(e) {
      e.preventDefault();
      if (this.announcement.photo) {
        const ob = {
          title: this.announcement.title,
          short_description: this.announcement.short_description,
          description: this.announcement.content,
          photo: this.announcement.photo,
          contact: this.announcement.contact,
          target: this.announcement.target,
          category: this.announcement.category,
          active: 0,
        };
        axios.post('/Announcement', ob).then(res => {
          if (String(res.status).charAt(0) == '2') {
            this.appStore.setIsSuccess('Pomyślnie dodano ogłoszenie');
            this.$router.push('/dla-biznesu/profile/announcements/');
          }
        });
      } else {
        this.appStore.setIsAlert('wgraj zdjęcie');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.biz-add-announcement-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.section-card-header {
  margin-bottom: 16px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.section-subtitle {
  margin: 6px 0 0 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.announcement-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  gap: 10px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
}

.form-group textarea {
  min-height: 130px;
  resize: vertical;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #10b981;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .biz-add-announcement-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
  .btn-outline,
  .btn-primary {
    width: 100%;
    text-align: center;
  }
}
</style>